import { useUserService } from '@/entities/user/api';
import { useOrderService } from '@/entities/order/api';
import { useCartService } from '@/entities/cart/api';
import { useDeliveryService } from '@/entities/delivery/api';
import { useBannersService } from '@/entities/banners/api';
import type { BannersService } from '@/entities/banners/model/types';
import { useProductsService } from '@/entities/products/api';
import { useCategoriesService } from '@/entities/categories/api';
import { useDiscountsService } from '@/entities/discounts/api';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      userService: useUserService(),
      orderService: useOrderService(),
      cartService: useCartService(),
      deliveryService: useDeliveryService(),
      bannersService: useBannersService() as BannersService,
      productsService: useProductsService(),
      categoriesService: useCategoriesService(),
      discountsService: useDiscountsService(),
    },
  };
});
